"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _paramsToObj = _interopRequireDefault(require("../utils/params-to-obj"));

var RESET_EXPERIMENT_QUERY_PARAM = 'rebucket';

var useResetExperiment = function useResetExperiment() {
  (0, _react.useEffect)(function () {
    if (undefined !== 'production') {
      var params = (0, _paramsToObj["default"])(window.document.location.search);

      if (params[RESET_EXPERIMENT_QUERY_PARAM]) {
        try {
          var _window$localStorage;

          (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.removeItem('telemetry_trackerUuid');
        } catch (e) {
          console.error(e);
        }

        window.document.location.search = '';
      }
    }
  }, []);
};

var _default = useResetExperiment;
exports["default"] = _default;